import type { UserFilterParams } from '@/types/api';

/** The manager the API embeds in a row; `null` when the employee has none. */
export interface EmployeeWithoutObjectiveManager {
    id: string;
    firstName: string;
    lastName: string;
}

/**
 * One employee with no objective in the selected cycle. Like everywhere else in the codebase the
 * job title and the department travel as ids: their labels are resolved company-side through
 * `useCompanyInformation`.
 */
export interface EmployeeWithoutObjective {
    id: string;
    firstName: string;
    lastName: string;
    profilePictureUrl: string | null;
    jobTitleId: string | null;
    departmentId: string | null;
    manager: EmployeeWithoutObjectiveManager | null;
}

/**
 * Query for `GET /Objective/EmployeesWithoutObjectives`. `from`/`to` are the selected cycle's
 * `'YYYY-MM-DD'` boundaries; the six company-attribute id arrays come from `toAttributeIdParams`
 * and are omitted when nothing is picked.
 */
export type EmployeesWithoutObjectivesParams = {
    from: string;
    to: string;
    /** 1-based, like every other paginated list in the app. */
    pageNumber: number;
    pageSize: number;
    searchQuery?: string;
} & UserFilterParams;

/** Four full rows of the page's three-column grid, so the last page is the only ragged one. */
export const EMPLOYEES_WITHOUT_OBJECTIVES_PAGE_SIZE = 12;
